import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { TravelStatusPageTabStatuses } from './types'

const TravelRequestViewChunk = lazy(() =>
  import('../feature-sets/TravelRequestView').then(({ TravelRequestView }) => ({
    default: TravelRequestView,
  }))
)

export const TravelRequestPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelRequestPageTitle)}
      breadcrumbs={[
        {
          link: url('TravelStatusPage', {
            status: TravelStatusPageTabStatuses.PENDING,
          }),
          name: intl.formatMessage(messages.travelStatusPageTitle),
        },
        {
          name: intl.formatMessage(messages.travelRequestPageTitle),
        },
      ]}
    >
      <TravelRequestViewChunk />
    </Page>
  )
}
